'use-strict';
import * as moment from 'moment';

export const APIURLTEST = "http://clintu-ws-test.azurewebsites.net/";
export const APIURLDEV = "http://localhost:3000/";
export const APIURLPROD = "https://api.clintu.es/";

export const PATTERNS = {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    postalCode: "^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$",
    dni: '^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$',
    phone: '^[0-9 \+]{8,14}$',
    cif: "^[a-zA-Z]{1}\\d{6,7}[a-jA-J0-9]{1}$",
    legalName: '^[a-zA-Z]{1}\\d{7}[a-jA-J0-9]{1}$',
    period: /^[0-9]{2}\/[0-9]{4}$/,
    //date: /^(([1-9]|1[012])[-/.]([1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d)|((1[012]|0[1-9])(3[01]|2\d|1\d|0[1-9])(19|20)\d\d)|((1[012]|0[1-9])[-/.](3[01]|2\d|1\d|0[1-9])[-/.](19|20)\d\d)$/
    date: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
    iban: "^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$"
}

export function getYears(yearsArray) {
    var actualYear = moment();

    for(var i = 0; i <= 10; i++){
        var string = actualYear.format("YYYY");
        yearsArray.push(string);
        actualYear.add(1, 'years');
    }
}



export function getProfAmount(service, profHour) {
    let n_hours = parseFloat(service["n_hours"]);
    let professionalAmount =  profHour * n_hours;
    if(service["with_products"] == 1){
        professionalAmount += 2;
    }
    if(service["transport_amount"] != null && service["transport_amount"] != '' && service["transport_amount"] != '0.00'){
        professionalAmount += parseFloat(service["transport_amount"]);
    }
    return professionalAmount;
}

export function getCommissionAmount(service, comHour) {
    let n_hours = parseFloat(service["n_hours"]);
    let comAmount  = n_hours * comHour;
    return  comAmount;
}

export function getFiltersOffice(){

    var offices = [
        {
            acronym: "BCN",
            name: "Barcelona"
        },
        {
            acronym: "MAD",
            name: "Madrid"
        },
        {
            acronym: "VLC",
            name: "Valencia"
        },
        {
            acronym: "BIO",
            name: "Bilbao"
        },
        {
            acronym: "ZAZ",
            name: "Zaragoza"
        },
        {
            acronym: "PM",
            name: "Palma de Mallorca"
        },
        {
            acronym: "ALC",
            name: "Alicante"
        },
        {
            acronym: "SLM",
            name: "Salamanca"
        },
        {
            acronym: "VLL",
            name: "Valladolid"
        },
        {
            acronym: "SEV",
            name: "Sevilla"
        },
        {
            acronym: "MAL",
            name: "Málaga"
        },
        {
            acronym: "GIJ",
            name: "Gijón"
        },
        {
            acronym: "OVI",
            name: "Oviedo"
        },
        {
            acronym: "LPA",
            name: "Las Palmas"
        },
        {
            acronym: "CDB",
            name: "Cordoba"
        },
        {
            acronym: "VIG",
            name: "Vigo"
        },
        {
            acronym: "ALV",
            name: "Alava"
        },
        {
            acronym: "CRÑ",
            name: "A Coruña"
        },
        {
            acronym: "GRA",
            name: "Granada"
        },
        {
            acronym: "ELC",
            name: "Elche"
        },
        {
            acronym: "CAD",
            name: "Cadiz"
        },
        {
            acronym: "JFR",
            name: "Jerez de la Frontera"
        },
        {
            acronym: "TNF",
            name: "Tenerife"
        },
        {
            acronym: "NAV",
            name: "Pamplona"
        },
        {
            acronym: "ALM",
            name: "Almería"
        },
        {
            acronym: "GUI",
            name: "San Sebastián"
        },
        {
            acronym: "BUR",
            name: "Burgos"
        },
        {
            acronym: "MBL",
            name: "Marbella"
        }

    ];

    return offices;
}
export function getOfficeName(id_office){
    
        var name;

        switch(id_office) {

            case 1: name = 'BCN';
            break;

            case 2: name = 'MAD';
            break;

            case 3: name = 'VLC';
            break;

            case 4: name = 'BIO';
            break;

            case 5: name = 'ZAZ';
            break;

            case 6: name = 'PM';
            break;

            case 7: name = 'ALC';
            break;

            case 8: name = 'SLM';
            break;

            case 9: name = 'VLL';
            break;

            case 10: name = 'SEV';
            break;

            case 11: name = 'MAL';
            break;

            case 12: name = 'GIJ';
            break;

            case 13: name = 'OVI';
            break;

            case 14: name = 'LPA';
            break;

            case 15: name = 'CDB';
            break;

            case 16: name = 'VIG';
            break;

            case 17: name = 'ALV';
            break;

            case 18: name = 'CRÑ';
            break;

            case 19: name = 'GRA';
            break;

            case 20: name = 'ELC';
            break;

            case 21: name = 'CAD';
            break;

            case 22: name = 'JFR';
            break;

            case 23: name = 'TNF';
            break;

            case 24: name = 'NAV';
            break;

            case 25: name = 'ALM';
            break;

            case 26: name = 'GUI';
            break;

            case 27: name = 'BUR';
            break;

            case 28: name = 'MBL';
            break;
        }

        return name;
}

export function getProvinces() {
    var provinces = [
        {
            name: "Barcelona",
            id: 1,
            acronym: "BCN",
            province: "08"
        },
        {
            name: "Madrid",
            id: 2,
            acronym: "MAD",
            province: "28"
        },
        {
            name: "Valencia",
            id: 3,
            acronym: "VLC",
            province: "46"
        },
        {
            name: "Bilbao",
            id: 4,
            acronym: "BIO",
            province: "48"
        },
        {
            name: "Zaragoza",
            id: 5,
            acronym: "ZAZ",
            province: "50"
        },
        {
            name: "Palma de Mallorca",
            id: 6,
            acronym: "PM",
            province: "56"
        },
        {
            name: "Alicante",
            id: 7,
            acronym: "ALC",
            province: "03"
        },
        {
            name: "Salamanca",
            id: 8,
            acronym: "SLM",
            province: "37"
        },
        {
            name: "Valladolid",
            id: 9,
            acronym: "VLL",
            province: "47"
        },
        {
            name: "Sevilla",
            id: 10,
            acronym: "SEV",
            province: "41"
        },
        {
            name: "Málaga",
            id: 11,
            acronym: "MAL",
            province: "29"
        },
        {
            name: "Gijón",
            id: 12,
            acronym: "GIJ",
            province: "33"
        },
        {
            name: "Oviedo",
            id: 13,
            acronym: "OVI",
            province: "033"
        },
        {
            name: "Las Palmas de Gran Canaria",
            id: 14,
            acronym: "LPA",
            province: "35"
        },
        {
            name: "Córdoba",
            id: 15,
            acronym: "CDB",
            province: "14"
        },
        {
            name: "Vigo",
            id: 16,
            acronym: "VIG",
            province: "36"
        },
        {
            name: "Vitoria-Gasteiz",
            id: 17,
            acronym: "ALV",
            province: "01"
        },
        {
            name: "A Coruña",
            id: 18,
            acronym: "CRÑ",
            province: "15"
        },
        {
            name: "Granada",
            id: 19,
            acronym: "GRA",
            province: "18"
        },
        {
            name: "Elche",
            id: 20,
            acronym: "ELC",
            province: "003"
        },
        {
            name: "Cadiz",
            id: 21,
            acronym: "CAD",
            province: "11"
        },
        {
            name: "Jerez de la Frontera",
            id: 22,
            acronym: "JFR",
            province: "011"
        },
        {
            name: "Santa Cruz de Tenerife",
            id: 23,
            acronym: "TNF",
            province: "38"
        },
        {
            name: "Pamplona",
            id: 24,
            acronym: "NAV",
            province: "31"
        },
        {
            name: "Almería",
            id: 25,
            acronym: "ALM",
            province: "04"
        },
        {
            name: "San Sebastián",
            id: 26,
            acronym: "GUI",
            province: "20"
        },
        {
            name: "Burgos",
            id: 27,
            acronym: "BUR",
            province: "09"
        },
        {
            name: "Marbella",
            id: 28,
            acronym: "MBL",
            province: "029"
        },

    ]

    return provinces;
}

export function getCities() {
    var cities = [
        {
            name: "Badalona",
            id: 1,
            office: 1,
            province: "08"
        },
        {
            name: "Barcelona",
            id: 2,
            office: 1,
            province: "08"
        },
        {
            name: "Cornellà",
            id: 3,
            office: 1,
            province: "08"
        },
        {
            name: "El Prat",
            id: 4,
            office: 1,
            province: "08"
        },
        {
            name: "Esplugues",
            id: 5,
            office: 1,
            province: "08"
        },
        {
            name: "Molins de Rei",
            id: 6,
            office: 1,
            province: "08"
        },
        {
            name: "Sant Boi de Llobregat",
            id: 7,
            office: 1,
            province: "08"
        },
        {
            name: "Sant Cugat",
            id: 8,
            office: 1,
            province: "08"
        },
        {
            name: "Sant Feliu",
            id: 9,
            office: 1,
            province: "08"
        },
        {
            name: "Sant Joan Despí",
            id: 10,
            office: 1,
            province: "08"
        },
        {
            name: "San Just Desvern",
            id: 11,
            office: 1,
            province: "08"
        },
        {
            name: "Santa Coloma de Gramenet",
            id: 12,
            office: 1,
            province: "08"
        },
        {
            name: "l'Hospitalet",
            id: 13,
            office: 1,
            province: "08"
        },
        {
            name: "Sant Adrià del Bessos",
            id: 14,
            office: 1,
            province: "08"
        },
        {
            name: "Alcorcón",
            id: 15,
            office: 2,
            province: "28"
        },
        {
            name: "Fuenlabrada",
            id: 16,
            office: 2,
            province: "28"
        },
        {
            name: "Getafe",
            id: 17,
            office: 2,
            province: "28"
        },
        {
            name: "Leganés",
            id: 18,
            office: 2,
            province: "28"
        },
        {
            name: "Madrid",
            id: 19,
            office: 2,
            province: "28"
        },
        {
            name: "Móstoles",
            id: 20,
            office: 2,
            province: "28"
        },
        {
            name: "Pozuelo",
            id: 21,
            office: 2,
            province: "28"
        },
        {
            name: "Pozuelo de Alarcón",
            id: 272,
            office: 2,
            province: "28"
        },
        {
            name: "Paterna",
            id: 22,
            office: 3,
            province: "46"
        },
        {
            name: "Valencia",
            id: 23,
            office: 3,
            province: "46"
        },
        {
            name: "Alboraia",
            id: 29,
            office: 3,
            province: "46"
        },
        {
            name: "Almàssera",
            id: 30,
            office: 3,
            province: "46"
        },
        {
            name: "Burjassot",
            id: 31,
            office: 3,
            province: "46"
        },
        {
            name: "Tavernes Blanques",
            id: 32,
            office: 3,
            province: "46"
        },
        {
            name: "Mislata",
            id: 33,
            office: 3,
            province: "46"
        },
        {
            name: "Paiporta",
            id: 34,
            office: 3,
            province: "46"
        },
        {
            name: "Picanya",
            id: 35,
            office: 3,
            province: "46"
        },
        {
            name: "Torrent",
            id: 36,
            office: 3,
            province: "46"
        },
        {
            name: "Manisses",
            id: 37,
            office: 3,
            province: "46"
        },
        {
            name: "Quart de Poblet",
            id: 50,
            office: 3,
            province: "46"
        },
        {
            name: "Bilbao",
            id: 24,
            office: 4,
            province: "48"
        },
        {
            name: "Getxo",
            id: 27,
            office: 4,
            province: "48"
        },
        {
            name: "Barkaldo",
            id: 28,
            office: 4,
            province: "48"
        },
        {
            name: "Basauri",
            id: 38,
            office: 4,
            province: "48"
        },
        {
            name: "Sestao",
            id: 39,
            office: 4,
            province: "48"
        },
        {
            name: "Portugalete",
            id: 40,
            office: 4,
            province: "48"
        },
        {
            name: "Santurtzi",
            id: 41,
            office: 4,
            province: "48"
        },
        {
            name: "Algorta",
            id: 42,
            office: 4,
            province: "48"
        },
        {
            name: "Areeta",
            id: 43,
            office: 4,
            province: "48"
        },
        {
            name: "Leioa",
            id: 44,
            office: 4,
            province: "48"
        },
        {
            name: "Astrabudúa",
            id: 45,
            office: 4,
            province: "48"
        },
        {
            name: "Zaragoza",
            id: 25,
            office: 5,
            province: "50"
        },
        {
            name: "Palma de Mallorca",
            id: 46,
            office: 6,
            province: "56"
        },
        {
            name: "Alicante",
            id: 47,
            office: 7,
            province: "03"
        },
        {
            name: "Salamanca",
            id: 48,
            office: 8,
            province: "37"
        },
        {
            name: "Valladolid",
            id: 49,
            office: 9,
            province: "47"
        },
        {
            name: "Sevilla",
            id: 51,
            office: 10,
            province: "41"
        },
        {
            name: "Málaga",
            id: 52,
            office: 11,
            province: "29"
        },
        {
            name: "Gijón",
            id: 53,
            office: 12,
            province: "33"
        },
        {
            name: "Oviedo",
            id: 54,
            office: 13,
            province: "033"
        },
        {
            name: "Las Palmas de Gran Canaria",
            id: 55,
            office: 14,
            province: "35"
        },
        {
            name: "Córdoba",
            id: 56,
            office: 15,
            province: "14"
        },
        {
            name: "Vigo",
            id: 47,
            office: 16,
            province: "36"
        },
        {
            name: "Vitoria-Gasteiz",
            id: 58,
            office: 17,
            province: "01"
        },
        {
            name: "A Coruña",
            id: 59,
            office: 18,
            province: "15"
        },
        {
            name: "Granada",
            id: 60,
            office: 19,
            province: "18"
        },
        {
            name: "Elche",
            id: 62,
            office: 20,
            province: "003"
        },
        {
            name: "Cádiz",
            id: 63,
            office: 21,
            province: "11"
        },
        {
            name: "Jerez de la Frontera",
            id: 64,
            office: 22,
            province: "011"
        },
        {
            name: "Santa Cruz de Tenerife",
            id: 65,
            office: 23,
            province: "38"
        },
        {
            name: "Pamplona",
            id: 66,
            office: 24,
            province: "31"
        },
        {
            name: "Almería",
            id: 71,
            office: 25,
            province: "04"
        },
        {
            name: "San Sebastián",
            id: 68,
            office: 26,
            province: "20"
        },
        {
            name: "Burgos",
            id: 69,
            office: 27,
            province: "09"
        },
        {
            name: "Marbella",
            id: 70,
            office: 28,
            province: "029"
        },
    ]

    return cities;
}

export function getLetters(){
    
    var offices = [
        {
            letter: "A"
        },
        {
            letter: "B"
        },
        {
            letter: "C"
        },
        {
            letter: "D"
        },
        {
            letter: "E"
        },
        {
            letter: "F"
        },
        {
            letter: "G"
        },
        {
            letter: "H"
        },
        {
            letter: "I"
        },
        {
            letter: "J"
        },
        {
            letter: "K"
        },
        {
            letter: "L"
        },
        {
            letter: "M"
        },
        {
            letter: "N"
        },
        {
            letter: "O"
        },
        {
            letter: "P"
        },
        {
            letter: "Q"
        },
        {
            letter: "R"
        },
        {
            letter: "S"
        },
        {
            letter: "T"
        },
        {
            letter: "U"
        },
        {
            letter: "V"
        },
        {
            letter: "W"
        },
        {
            letter: "X"
        },
        {
            letter: "Y"
        },
        {
            letter: "Z"
        }

     ];


    return offices;
}

export function getAcronym(city) {
    let acronym;
    switch(city) {

        case 'Madrid': acronym = 'MAD';
        break;

        case 'Barcelona': acronym = 'BCN';
        break;

        case 'Valencia': acronym = 'VLC';
        break;

        case 'Bilbao': acronym = 'BIO';
        break;

        case 'Zaragoza': acronym = 'ZAZ';
        break;

        case 'Palma de Mallorca': acronym = 'PM';
        break;

        case 'Alicante': acronym = 'ALC';
        break;

        case 'Salamanca': acronym = 'SLM';
        break;

        case 'Valladolid': acronym = 'VLL';
        break;

        case 'Sevilla': acronym = 'SEV';
        break;

        case 'Málaga': acronym = 'MAL';
        break;

        case 'Gijón': acronym = 'GIJ';
        break;

        case 'Oviedo': acronym = 'OVI';
        break;

        case 'Las Palmas': acronym = 'LPA';
        break;

        case 'Cordoba': acronym = 'CDB';
        break;

        case 'Vigo': acronym = 'VIG';
        break;

        case 'Alava': acronym = 'ALV';
        break;

        case 'A Coruña': acronym = 'CRÑ';
        break;

        case 'Granada': acronym = 'GRA';
        break;

        case 'Elche': acronym = 'ELC';
        break;

        case 'Cadiz': acronym = 'CAD';
        break;

        case 'Jerez de la Frontera': acronym = 'JFR';
        break;

        case 'Tenerife': acronym = 'TNF';
        break;

        case 'Pamplona': acronym = 'NAV';
        break;

        case 'Almeria': acronym = 'ALM';
        break;

        case 'Guipuzcoa': acronym = 'GUI';
        break;

        case 'Burgos': acronym = 'BUR';
        break;

        case 'Marbella': acronym = 'MBL';
        break;
    }

    return acronym;
}



// WEBPACK FOOTER //
// ./src/app/globals.ts